<template>
    <CodiceFeanorView tool-module="atbash" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
